import { render, staticRenderFns } from "./warehousingWorkspace.vue?vue&type=template&id=0d56f0fe&"
import script from "./warehousingWorkspace.vue?vue&type=script&lang=js&"
export * from "./warehousingWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./warehousingWorkspace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d56f0fe')) {
      api.createRecord('0d56f0fe', component.options)
    } else {
      api.reload('0d56f0fe', component.options)
    }
    module.hot.accept("./warehousingWorkspace.vue?vue&type=template&id=0d56f0fe&", function () {
      api.rerender('0d56f0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Warehouse/components/warehousing/warehousingWorkspace.vue"
export default component.exports